import React from "react";
import "./PinControl.css";

const PinControl = ({ isPinned, onTogglePin }) => {
  return (
    <button
      className={`pin-control ${isPinned ? "pinned" : ""}`}
      onClick={onTogglePin}
      title={isPinned ? "Unpin header" : "Pin header"}
      aria-label={isPinned ? "Unpin header" : "Pin header"}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isPinned ? (
          <path
            d="M16 9V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5a2 2 0 0 1-.586 1.414L5 12.828V14h6v7l1 1 1-1v-7h6v-1.172l-2.414-2.414A2 2 0 0 1 16 9z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M16 9V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5a2 2 0 0 1-.586 1.414L5 12.828V14h6v7l1 1 1-1v-7h6v-1.172l-2.414-2.414A2 2 0 0 1 16 9z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        )}
      </svg>
    </button>
  );
};

export default PinControl;
